import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import Pagination from "../pagination/pagination";
import PodListSearchForm from "./pod-list-search-form";
import PodListTable from "./pod-list-table";

export default function PodList(props) {
  // page of pod results;
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  // pods to display (will be populated by an Ajax call);
  const [pods, setPods] = useState([]);
  // search string;
  const [search, setSearch] = useState(``);
  // list sort value;
  const [sort, setSort] = useState(`-created`);
  // search status;
  const [status, setStatus] = useState(null);
  // list sort value;
  const [usage, setUsage] = useState(``);
  // pass to sort and pagination links to maintain search state;
  const [queryString, setQueryString] = useState(``);

  useEffect(() => {
    const pageNumber = Number(_.get(props, `params.page`, 1));
    const searchString = _.get(props, `location.query.search`, ``);
    const sortOrder = _.get(props, `location.query.sort`, `-created`);
    const awsStatus = Number(_.get(props, `location.query.status`, 0)) || null;
    const usageFilter = _.get(props, `location.query.unused`, ``);

    setPage(pageNumber);
    setSearch(searchString);
    setSort(sortOrder);
    setStatus(awsStatus);
    setUsage(usageFilter);
    setQueryString(_.get(props, `location.search`, null));

    // get the pod data to display (one page at a time);
    const getPods = () => {
      util
        .getPods({
          page: pageNumber,
          search: searchString,
          sort: sortOrder,
          aws_status: awsStatus,
          unused: usageFilter
        })
        .then(data => {
          setTimeout(() => {
            setPods(data.results.length ? data.results : false);
            setPageCount(Math.ceil(data.count / util.podResultsPerPage));
          }, util.delayList);
        });
    };

    getPods();
  }, [props]);

  const searchSubmit = params => {
    setSearch(params.search);
    setStatus(params.status);
    setUsage(params.usage);
    setSort(params.sort);

    browserHistory.push(params.url);
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__title">Pods</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <Link to={util.returnPodFormUrl()} className="btn btn-primary">
              <i className="fa fa-plus" aria-hidden="true"></i>
              Create New Pod
            </Link>
          </p>
        </div>
      </div>

      <PodListSearchForm
        search={search}
        sort={sort}
        status={status}
        unused={usage}
        searchSubmit={params => searchSubmit(params)}
      />

      <PodListTable
        currentPage={page}
        pods={pods}
        queryString={queryString}
        sort={sort}
      />

      <Pagination
        currentPage={page}
        pageCount={pageCount}
        path="pods"
        queryString={queryString}
      />
    </div>
  );
}

PodList.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object
};
